export enum APP_FEATURES {
  PRIVATE_INBOX = "privateInbox",
  ENTITIES_SELECTION = "entitiesSelection",
  BETA_ACCESS_PROMPT_DIALOG = "betaAccessPromptDialog",
  TRACK_VERSION_EDITOR = "trackVersionEditor",
}

export const AppFeaturesStatus: Record<APP_FEATURES, boolean> = {
  [APP_FEATURES.PRIVATE_INBOX]: false,
  [APP_FEATURES.ENTITIES_SELECTION]: false,
  [APP_FEATURES.BETA_ACCESS_PROMPT_DIALOG]: true,
  [APP_FEATURES.TRACK_VERSION_EDITOR]: true,
};
